var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c(
      "span",
      {
        directives: [
          {
            name: "tooltip",
            rawName: "v-tooltip",
            value: "Razón Social Receptor",
            expression: "'Razón Social Receptor'"
          }
        ],
        staticClass: "razon-social"
      },
      [_vm._v(" " + _vm._s(_vm.documento.razonSocialReceptor) + " ")]
    ),
    _c("span", { staticClass: "rut-receptor" }, [
      _vm._v(" RUT: " + _vm._s(_vm.formatRut(_vm.documento.rutReceptor)))
    ]),
    _c(
      "div",
      [
        _c(
          "vs-chip",
          {
            directives: [
              {
                name: "tooltip",
                rawName: "v-tooltip",
                value: "Aduana Coordinadora",
                expression: "'Aduana Coordinadora'"
              }
            ],
            attrs: { color: "primary" }
          },
          [
            _vm.aduanasCoordinadoras[_vm.documento.rutEmisor]
              ? _c("span", [
                  _vm._v(
                    " " +
                      _vm._s(
                        _vm.aduanasCoordinadoras[_vm.documento.rutEmisor]
                      ) +
                      " "
                  )
                ])
              : _vm._e(),
            !_vm.aduanasCoordinadoras[_vm.documento.rutEmisor]
              ? _c("span", [_vm._v(" - ")])
              : _vm._e()
          ]
        ),
        _c("vs-chip", { attrs: { color: _vm.colores.navbar } }, [
          _vm._v(
            " " +
              _vm._s(
                _vm.traducitTipoDocumentoEnPalabras(_vm.documento.tipoDocumento)
              ) +
              " "
          )
        ]),
        _c(
          "vs-chip",
          {
            directives: [
              {
                name: "tooltip",
                rawName: "v-tooltip",
                value: "Folio",
                expression: "'Folio'"
              }
            ],
            attrs: { color: "#aaa" }
          },
          [_vm._v(" # " + _vm._s(_vm.documento.folio) + " ")]
        )
      ],
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }